import { defineMessages } from 'react-intl';

export default defineMessages({
  fullyPaidUnsettledFunds: {
    id: 'sentinel.components.detailsPanel.fullyPaidUnsettledFunds',
    defaultMessage: 'Allows Fully Paid Unsettled Funds',
  },
});



// WEBPACK FOOTER //
// ./src/components/DetailsPanel/messages.js